import React from 'react';

function ResultsDisplay({ result }) {
  if (!result) return null;

  return (
    <div className="container" style={{ marginTop: '40px' }}>
      <h3 data-testid="optimal-weights-raw">Optimal Weights (Raw Data):</h3>
      <ul>
        {result.map((weight, index) => (
          <li key={index}>{`Asset ${index + 1}: ${weight.toFixed(4)}`}</li>
        ))}
      </ul>
    </div>
  );
}

export default ResultsDisplay;
